import React from 'react';

const EacIcon = () => {

  return (
    <svg width="95" height="95" viewBox="0 0 95 95" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="95" height="95" fill="black" />
      <path fillRule="evenodd" clipRule="evenodd" d="M58.4928 17.8384H51.0255V17.8384H44.8033H37.3361V25.3057V44.8035H37.3358V52.2707H37.3361V77.1616H44.8033V52.2707H51.0255V77.1615H58.4928V52.2707H58.493V44.8035H58.4928V25.3057H58.4933V17.8384H58.4928V17.8384ZM51.0255 25.3057H44.8033V44.8035H51.0255V25.3057Z" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd" d="M22.4021 17.8384H14.9349V25.3056V44.3887H14.9346V51.8559H14.9349V69.6943H14.9346V77.1615H31.9433V69.6943H22.4021V51.8559H31.9433V44.3887H22.4021V25.3056H31.9436V17.8384H22.4021Z" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd" d="M63.4714 17.8384H70.9387H80.4801V25.3056H70.9387V69.6943H80.4799V77.1615H63.4712V69.6943H63.4714V25.3056V17.8384Z" fill="white" />
    </svg>
  );

};

export default EacIcon;
